import PreloadView from "../../../vendor_core/core/src/views/PreloadView";
import RelaxPOSTMessageController from "../../../vendor_core/server/RelaxPOSTMessageController";

export default class BBPreloadView extends PreloadView {
    constructor() {
        super();
    }

    protected setProgress(progress: number): void {
        super.setProgress(progress);
        RelaxPOSTMessageController.gameLoadProgress(progress * 100);
    }
}
